var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-linkedin';
                    var viewUrl = 'sprite.svg#view-icon-linkedin';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };